import { TABS_EXPORT_STATE_KEY } from './export-reducer';

// Get whole slice
export const getTabsExportState = (state: any) => state[TABS_EXPORT_STATE_KEY];
export const getActiveTab = (state: any) => getTabsExportState(state).activeTab;
export const getTabsData = (state: any) => getTabsExportState(state).data;
export const getToggleValue = (state: any) => getTabsExportState(state).toggleValue;
export const getSelectedForActive = (state: any) => {
  const active = getActiveTab(state);
  if (!active) return new Set<string>();
  return getTabsExportState(state).selected[active] || new Set<string>();
};

export const getIsSubmitting = (state: any) => getTabsExportState(state).submitting;
